<template src="./paladin-member-export.html"></template>

<script>

import { ChiRhosNext } from "@paladin/core"

import Multiselect from "vue-multiselect"

// import PaladinFilterSet from '../../../library/components/filterset/paladin-filterset'
import { PaladinFilterSet, } from '@paladin/core-components'

import _ from 'lodash'

const ChiRhosNextApi = new ChiRhosNext().api()

export default {
components: { Multiselect, PaladinFilterSet },
  // components: { PaladinReport, },
  props: {
    activeGroup: {
      type: Object,
      required: true,
    },
    allRoles: {
     type: Array,
     default: null
    },
  },
  data() {
    return {
      fields:{
        genderType: true,
        title: true,
        firstName: true,
        middleName: true,
        lastName: true,
        alternativeLastName: false,
        mobilePhone: true,
        alternativePhone: false,
        email: true,
        alternativeEmail: false,
        dateOfBirth: true,
        maritalStatus: false,
        isHidden: false,
        isDetailInDirectory: false,
        address: false,
        communicationSettings: false,
      },
      exportData: null,
      showExport: false,
      running: false,
      existing: null,
      groupTypes: [],
      saved: [],
      useAbsence: false,
      absent: {
        since: null,
        event: null,
      },
      selectedRoles: [],
      model: {
        belongsTo: null,
        name: '',
        includeChildren: false,
        limitChildrenGroupTypes: [],
        when: null,
        roles: [],
        person: null,
        absent: null,
        fields: [],
      },
      key: 'initial',
      absentEventPreset: null,
      modelPersonPreset: null,
    }
  },
  computed: {
   groupTypeOptions: function() {
      return this.groupTypes.map(item => {
        return {
          value: item.entity.entityId,
          text: item.entity.name
        }
      })
    },
    savedOptions: function() {
      if (this.saved) {
        return this.saved.map(item => {
          return {
            value: item.entity.entityId,
            text: item.entity.name
          }
        })
      } else {
        return []
      }
    },
    computedExportData() {

      return this.exportData
        ? this.exportData.map((person) => {
            let _row = { }

            if(this.fields.genderType) {
              _row['Gender'] = person.genderType }
            if(this.fields.title) {
              _row['Title'] = person.title }
            if(this.fields.firstName) {
              _row['First Name'] = person.firstName }
            if(this.fields.middleName) {
              _row['Middle Name'] = person.middleName }
            if(this.fields.lastName) {
              _row['Last Name'] = person.lastName }
            if(this.fields.alternativeLastName) {
              _row['Last Name (Other)'] = person.alternativeLastName }
            if(this.fields.mobilePhone) {
              _row['Mobile Phone'] = person.mobilePhone }
            if(this.fields.alternativePhone) {
              _row['Phone (Other)'] = person.alternativePhone }
            if(this.fields.email) {
              _row['Email'] = person.email }
            if(this.fields.alternativeEmail) {
              _row['Email (Other)'] = person.genderalternativeEmailType }
            if(this.fields.dateOfBirth) {
              _row['Date of Birth'] = person.dateOfBirth }
            if(this.fields.maritalStatus) {
              _row['Married'] = person.maritalStatus }
            if(this.fields.isHidden) {
              _row['Is Hidden'] = person.isHidden }
            if(this.fields.isDetailInDirectory) {
              _row['Is in Directory'] = person.isDetailInDirectory }
            if(this.fields.address) {
              _row['Address Line 1'] = person.address ? person.address.line1 : ''
              _row['Address Line 2'] = person.address ? person.address.line2 : ''
              _row['Address City'] = person.address ? person.address.city : ''
              _row['Address State'] = person.address ? person.address.state : ''
              _row['Address Postal Code'] = person.address ? person.address.postalCode : ''
              _row['Address Country'] = person.address ? person.address.country : ''
              }
            if(this.fields.communicationSettings) {
              _row['Notification Email'] = person.communicationSettings && person.communicationSettings.notifications ? person.communicationSettings.notifications.email : false
              _row['Notification SMS'] = person.communicationSettings  && person.communicationSettings.notifications ? person.communicationSettings.notifications.sms : false
              _row['Notification Push'] = person.communicationSettings  && person.communicationSettings.notifications ? person.communicationSettings.notifications.whatsApp : false
              _row['Marketing Email'] = person.communicationSettings  && person.communicationSettings.marketing ? person.communicationSettings.marketing.email : false
              _row['Marketing SMS'] = person.communicationSettings  && person.communicationSettings.marketing ? person.communicationSettings.marketing.sms : false
              _row['Marketing Push'] = person.communicationSettings  && person.communicationSettings.marketing ? person.communicationSettings.marketing.whatsApp : false
              }

          return _row
          })
        : []
    },
  },
  watch: {
  },
  created: function() {
  },
  mounted() {
    this.$nextTick(function() {
      this.init()
    })
  },
  methods: {
    init() {

      this.model.belongsTo = this.activeGroup.entity.entityId

      ChiRhosNextApi.GroupTypeApi.listDescendantGroupTypes({
        entityId: this.activeGroup.entity.type
      }).then(
        response => {
          this.groupTypes = response.data
          this.loadSavedExports()
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    },
    loadSavedExports()
    {
      ChiRhosNextApi.PersonApi.membershipExportList({
        entityId: this.activeGroup.entity.entityId
      }).then(
        response => {
          this.saved = response.data ? response.data : []
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    },
    updatePersonFilter(filter)
    {
      this.model.person = filter
    },
    updateEventFilter(filter)
    {
      this.absent.event = filter
    },
    loadExport()
    {
      if(this.existing)
      {
        var item = this.saved.find(op => {
          return op.entity.entityId === this.existing
        })

        if (item) {
          this.model.name = item.entity.name
          this.model.includeChildren = item.entity.includeChildren
          this.model.limitChildrenGroupTypes = item.entity.limitChildrenGroupTypes ? item.entity.limitChildrenGroupTypes : []
          this.model.when = item.entity.when
          this.model.roles = item.entity.roles ? item.entity.roles : []

          this.selectedRoles = []

          if(item.entity.roles)
          {
            let _roles = item.entity.roles
            let _selectedRoles = this.selectedRoles

            this.allRoles.forEach(function(role) {
              if(_roles.includes(role.value))
              {
                _selectedRoles.push(role)
              }
            })
          }

          this.model.person = item.entity.person
          this.modelPersonPreset = item.entity.person ? _.clone(item.entity.person, true) : null
          this.model.fields = []

          this.fields.genderType = item.entity.fields ? item.entity.fields.includes('genderType') : false
          this.fields.title =  item.entity.fields ? item.entity.fields.includes('title') : false
          this.fields.firstName =  item.entity.fields ? item.entity.fields.includes('firstName') : false
          this.fields.middleName =  item.entity.fields ? item.entity.fields.includes('middleName') : false
          this.fields.lastName =  item.entity.fields ? item.entity.fields.includes('lastName') : false
          this.fields.alternativeLastName =  item.entity.fields ? item.entity.fields.includes('alternativeLastName') : false
          this.fields.mobilePhone =  item.entity.fields ? item.entity.fields.includes('mobilePhone') : false
          this.fields.alternativePhone =  item.entity.fields ? item.entity.fields.includes('alternativePhone') : false
          this.fields.email = item.entity.fields ? item.entity.fields.includes('email') : false
          this.fields.alternativeEmail = item.entity.fields ? item.entity.fields.includes('alternativeEmail') : false
          this.fields.dateOfBirth = item.entity.fields ? item.entity.fields.includes('dateOfBirth') : false
          this.fields.maritalStatus =  item.entity.fields ? item.entity.fields.includes('maritalStatus') : false
          this.fields.isHidden =  item.entity.fields ? item.entity.fields.includes('isHidden') : false
          this.fields.isDetailInDirectory =  item.entity.fields ? item.entity.fields.includes('isDetailInDirectory') : false
          this.fields.address =  item.entity.fields ? item.entity.fields.includes('address') : false
          this.fields.communicationSettings =  item.entity.fields ? item.entity.fields.includes('communicationSettings') : false

          if(item.entity.absent)
          {
            this.useAbsence = true
            this.absent.since = item.entity.absent.since
            this.absent.event = item.entity.absent.event
            this.absentEventPreset = _.clone(item.entity.absent.event, true)
          }
          else
          {
            this.useAbsence = false
            this.absent.since = null
            this.absent.event = null
            this.absentEventPreset = null
          }
          this.key = this.existing
        }
      }
      else
      {
        this.model.name = ''
        delete this.model.entityId
        this.key = 'default'
      }
    },
    saveAsExport()
    {
      this.existing = null

      this.saveExport()
    },
    prepareModel()
    {
      if(!this.useAbsence)
      {
        this.model.absent = null
      }
      else
      {
        if(!this.absent.since)
        {
            this.$toast("If using absence, you must enter a Since date", "error")
            return
        }

        this.model.absent = this.absent
      }

      if(this.existing)
      {
        this.model.entityId = this.existing
      }

      this.model.roles = []

      if(this.selectedRoles)
      {
        let _roles = this.model.roles

        this.selectedRoles.forEach(function (role) {
          _roles.push(role.value)
        })
      }

      this.model.fields = []

      if(this.fields.genderType) this.model.fields.push('genderType')
      if(this.fields.title) this.model.fields.push('title')
      if(this.fields.firstName) this.model.fields.push('firstName')
      if(this.fields.middleName) this.model.fields.push('middleName')
      if(this.fields.lastName) this.model.fields.push('lastName')
      if(this.fields.alternativeLastName) this.model.fields.push('alternativeLastName')
      if(this.fields.mobilePhone) this.model.fields.push('mobilePhone')
      if(this.fields.alternativePhone) this.model.fields.push('alternativePhone')
      if(this.fields.email) this.model.fields.push('email')
      if(this.fields.alternativeEmail) this.model.fields.push('alternativeEmail')
      if(this.fields.dateOfBirth) this.model.fields.push('dateOfBirth')
      if(this.fields.maritalStatus) this.model.fields.push('maritalStatus')
      if(this.fields.isHidden) this.model.fields.push('isHidden')
      if(this.fields.isDetailInDirectory) this.model.fields.push('isDetailInDirectory')
      if(this.fields.address) this.model.fields.push('address')
      if(this.fields.communicationSettings) this.model.fields.push('communicationSettings')
    },
    saveExport()
    {
      this.prepareModel()

      if(!this.model.name)
      {
          this.$toast("You must enter a name", "error")
          return
      }

      ChiRhosNextApi.PersonApi.membershipExportSave(this.model).then(
        response => {
          this.loadSavedExports()
          this.$toast("Export saved", "success")
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    },
    runExport()
    {
      this.prepareModel()

      this.running = true;

      ChiRhosNextApi.PersonApi.membershipExportRun(this.model).then(
        response => {
          this.$toast("Export successful!", "success")
          if(this.running)
          {
            this.running = false
            this.exportData = response.data
            this.showExport = true
          }
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    },
    cancelRunning()
    {
      this.running = false
    },
    closeExport()
    {
      this.showExport = false
    },
    deleteExport()
    {
      ChiRhosNextApi.PersonApi.membershipExportDelete(this.existing).then(
        response => {
          this.$toast("Export deleted!", "success")
          this.existing = null
          delete this.model.entityId
          this.model.name = ''
          this.loadSavedExports()
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    },
    downloadCsv()
    {
      if(!this.computedExportData)
      {
        this.$toast("Nothing to export", "error")
        return
      }

      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(this.computedExportData[0]).join(","),
          ...this.computedExportData.map(item => Array.from(Object.values(item),
          (x) => x != null ? x.toString().includes(',') ? '"' + x.toString() + '"' : x : '').join(","))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },
  },
}
</script>

<style lang="scss"></style>
